var _rect, _path, _circle, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolunteer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.240234,
    y: 0.939453,
    width: 41.6947,
    height: 41.6947,
    rx: 11.8004,
    fill: "#FFEBD7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.005 17.2799V15.2312C26.005 14.3261 25.2712 13.5923 24.366 13.5923H15.3518C14.4467 13.5923 13.7129 14.3261 13.7129 15.2312V25.8844C13.7129 26.7895 14.4467 27.5233 15.3518 27.5233H20.2687",
    stroke: "#F97210",
    strokeWidth: 1.47505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.0053,
    cy: 22.1967,
    r: 2.45842,
    stroke: "#F97210",
    strokeWidth: 1.47505
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0044 26.7036C24.243 26.7036 23.4281 27.6502 23.0511 28.526C22.7236 29.2869 23.3981 29.9815 24.2266 29.9815H27.7823C28.6108 29.9815 29.2853 29.2869 28.9578 28.526C28.5808 27.6502 27.7659 26.7036 26.0044 26.7036Z",
    stroke: "#F97210",
    strokeWidth: 1.47505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9902 16.8696H22.7265",
    stroke: "#F97210",
    strokeWidth: 1.47505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9902 19.7378L20.2681 19.7378",
    stroke: "#F97210",
    strokeWidth: 1.47505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteer);
export default __webpack_public_path__ + "static/media/volunteer.b46577930a339c9ef9ba1401f5514571.svg";
export { ForwardRef as ReactComponent };